'use client';

import { setLastSelectedCity } from "@/lib/LocalStorage";
import { loadLocationsFromBackend } from "@/lib/LocationListHelper";
import { districtToUrl } from "@/lib/utils";
import { City, District } from "@/models/City";
import { useEffect } from "react";

type Props = {
  path: string;
};

export default function DistrictSetter(props: Props) {

    useEffect(() => {
      const updateUrl = async () => {
        const locations = await loadLocationsFromBackend();
        if (!locations?.districts?.length || !locations?.cities?.length) {
          return;
        }

        const { districts, cities } = locations;

        let matchedDistrict: District | undefined = undefined;
        let matchedCity: City | undefined = undefined;

        districts.forEach((district) => {
          if (districtToUrl(district, cities)?.toString() == '/bolge/' + props.path) {
            matchedDistrict = district;
            matchedCity = cities.find((city) => city.id === district.cityId);
          }
        });

        if (matchedDistrict) {
          setLastSelectedCity(matchedCity, matchedDistrict);
        }
      }

      updateUrl();

    }, [props.path]);  
    
    return null;
}